export default {
  namespaced: true,
  state: {
    loading: !process.env.VUE_APP_WX_APP_ID,
    aliveTime: 0,
    screenWidth: document.documentElement.offsetWidth || document.body.offsetWidth,
    screenHeight: document.documentElement.offsetHeight || document.body.offsetHeight
  },
  mutations: {
    setLoading (state, data) {
      state.loading = data
    },
    updateAliveTime (state) {
      state.aliveTime = new Date().getTime()
    },
    refreshScreenSize (state) {
      state.screenWidth = document.documentElement.offsetWidth || document.body.offsetWidth
      state.screenHeight = document.documentElement.offsetHeight || document.body.offsetHeight
    }
  }
}
